
import React from "react";
import { useAuth } from "@/context/AuthContext";

const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 12) return "Goedemorgen";
  if (hour >= 12 && hour < 18) return "Goedemiddag";
  return "Goedenavond";
};

const DashboardWelcome = () => {
  const { user } = useAuth();
  const greeting = getGreeting();

  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight">{greeting}, {user?.name}</h1>
      <p className="text-muted-foreground">
        {user?.role === "medewerker" && "Verwerk orders en houd voorraad bij"}
        {user?.role === "planner" && "Beheer planning en controleer voorraad"}
        {user?.role === "management" && "Bekijk rapportages en overzichten"}
      </p>
    </div>
  );
};

export default DashboardWelcome;
